export default __webpack_public_path__ + "static/high-five-illustration@2x-b458c4f6a248f0b236a88b26e8df0acb.png";